import React from 'react';
import BulletList from '../../../../../../../../common/component/BulletList';

const AddonConsumerGuide = ({ section, onTncClick }) => (
  <div className="addon-consumer-guide">
    <BulletList section={section} onTncClick={onTncClick} />
  </div>
);

export default AddonConsumerGuide;
